export function requiredRule(
  message = "Campo Obrigatório"
): (value: any) => boolean | string {
  return (value) => !!value || value === 0 || message;
}
